import { ClientEntityRef } from '../../types/agentTypes'
import { axiosClient } from '../axiosClient'

export const clientEntityFunctions = {
  // Superuser's associated client entities (superuser-only endpoint).
  fetchClientEntities: async (): Promise<ClientEntityRef[]> => {
    return await axiosClient.get('api/client-entities/')
  },
}
